import { toSubaruNumber } from '@utils/convert';

export const getLowerstPrice = (priceList) => {
  const priceFrom = priceList?.elements?.reduce((prev, curr) => {
    return prev.price < curr.price ? prev : curr;
  });

  return priceFrom ? toSubaruNumber(priceFrom.price) : '';
};
